// --------------------------------------------------------------------------
// #? Prevent multiple form submission
// --------------------------------------------------------------------------
// Author:      RSPB    
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context, $document: $(document) };

    function init() {
        ref.$form = ref.$root.closest('form');

        // add the full screen loading screen to the DOM
        ref.$root.closest('body').prepend('<div class="full-screen-ajax-loading"><img class="bird-identifier__loading__img" src="/Static/images/ajax-loading.gif" alt="Please wait whilst the web page loads"><p>Submitting form. Please wait...</p></div>');

        ref.$form.on('submit', function (e) {
            if (ref.$form.data('submitted') === true) {
                // don't submit again
                e.preventDefault();
            } else {
                // check if the form is valid (only if valid() function is present)
                if (typeof ref.$form.valid !== 'function' || ref.$form.valid()) {
                    // flag it as submitted
                    ref.$form.data('submitted', true);
                    // display full screen loading screen
                    ref.$document.find('.full-screen-ajax-loading').css('display', 'block');
                    // the form is being submitted now
                }
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/prevent-multiple-submission.js
// module id = 513
// module chunks = 0